module.exports = __webpack_public_path__ + "static/img/homeright3.3c4e6c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright3.png
// module id = 76yb
// module chunks = 13